import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { PedidoConsultaOutput } from 'src/app/@shared/models/consulta-detalhe';
import { DetalheFormularioComponent } from './bloco-busca/detalhe-formulario/detalhe-formulario.component';

@Component({
  selector: 'app-consulta-detalhe',
  templateUrl: './consulta-detalhe.component.html',
  styleUrls: ['./consulta-detalhe.component.scss']
})
export class ConsultaDetalheComponent implements OnInit {
  isLoading: Boolean;
  cliente: any;
  urlParams: any;
  tabIndex: any;

  pedido: PedidoConsultaOutput; // carregar detalhes do pedido, criar model correto
  @ViewChild('formulariobusca') formPesquisa: DetalheFormularioComponent;

  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
  ) { }

  ngAfterViewInit() {
    this.formPesquisa.onSearchResult.subscribe((pedido : PedidoConsultaOutput) =>{
      this.pedido = pedido;
      this.isLoading = false;
    });

    this.formPesquisa.onLoadingChange.subscribe(isLoading =>{
      this.isLoading = isLoading;
    });
  }

  ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
      this.urlParams = { ...params };
    });
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

  novaConsulta() {
    this.pedido = null;
    this.tabIndex = 0;
    this.formPesquisa.formAGCC.formAgenciaConta.reset();
    this.formPesquisa.formIDCONTA.formConsultaIdConta.reset();
    this.formPesquisa.formNFE.formConsultaNfe.reset();
    this.formPesquisa.formNRASTREIO.formNumeroRastreio.reset();
    this.formPesquisa.formNRT.formConsultaNrt.reset();
    this.formPesquisa.formREGISTROCLIENTE.formRegistroCliente.reset();
  }
}
